import {Button} from 'react-bootstrap';
import React from 'react';
import classNames from 'clsx';
import {useTranslation} from 'react-i18next';
import {Icons} from '../icons/icons';
import {SvgIcon} from '../icons/svgIcon';
import {FacetFilterWidget} from './facetFilterWidget';
import {buildDefaultFieldTitle} from '../utils/utils';

type FacetGroupComponentProps = {
    onClick: () => void;
    isExpanded: boolean;
    fieldName: string;
    isSearchable: boolean;
    filter: string;
    setFilter?: (filter: string) => void;
};

export const FacetGroupHeader = React.memo((props: FacetGroupComponentProps) => {
    const {t} = useTranslation();

    const renderFacetGroupHeader = () => {
        const title = t('fieldTitle.' + props.fieldName + '.label', buildDefaultFieldTitle(props.fieldName));

        const alt = props.isExpanded ? t('facets.icon.collapse') : t('facets.icon.expand');

        return (
            <div
                className={classNames('list-group-item-title-wrapper')}
                onClick={props.onClick}
            >
                <div className="list-group-item-title">
                    <Button className="drop-down-button">
                        <SvgIcon
                            icon={Icons.CHEVRON_DOWN}
                            alt={alt}
                            className={props.isExpanded ? 'facet-group-expanded' : ''}
                        />
                    </Button>
                    {title}
                </div>
                {props.isExpanded && props.isSearchable && props.setFilter && (
                    <FacetFilterWidget filter={props.filter} setFilter={props.setFilter} title={title}/>
                )}
            </div>
        );

    };

    return renderFacetGroupHeader();
});
